function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_1",
  "data-name": "Group 1",
  transform: "translate(-152 -439)"
}, /*#__PURE__*/React.createElement("line", {
  id: "Line_1",
  "data-name": "Line 1",
  y1: 14.91,
  transform: "translate(184 463.788)",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1",
  "data-name": "Path 1",
  d: "M6,9.155,10.949,5",
  transform: "translate(173.051 458.302)",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2",
  "data-name": "Path 2",
  d: "M10.949,5,15.9,9.155",
  transform: "translate(173.051 458.302)",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_1",
  "data-name": "Ellipse 1",
  transform: "translate(152 439)",
  fill: "none",
  strokeWidth: 2.5
}, /*#__PURE__*/React.createElement("circle", {
  cx: 32,
  cy: 32,
  r: 32,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  id: "circle",
  cx: 32,
  cy: 32,
  r: 30.75,
  fill: "none"
})));

function SvgUpArrowCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrowCircle);
export default __webpack_public_path__ + "static/media/up-arrow-circle.c73c7001.svg";
export { ForwardRef as ReactComponent };